import { useEffect, useState } from "react";

import { readCookie } from "@/utils/readCookie";

const FBP_COOKIE_KEY = "_fbp";
const FBC_COOKIE_KEY = "_fbc";

const useMetaCookies = () => {
    const [fbp, setFbp] = useState<string | null>(null);
    const [fbc, setFbc] = useState<string | null>(null);

    useEffect(() => {
        const fbpCookie = readCookie(FBP_COOKIE_KEY);
        const fbcCookie = readCookie(FBC_COOKIE_KEY);
        setFbp(fbpCookie);
        setFbc(fbcCookie);
    }, []);

    return {
        fbp,
        fbc,
    };
};
export default useMetaCookies;
